function NotFound() {
  return (
    <div>
      <h2>404 Not found</h2>
    </div>
  );
}
export default NotFound;
